module.exports = __webpack_public_path__ + "static/media/soldier01.6e70bb56.png";